import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Import pages
import Home from './pages/Home';
import Quiz from './pages/Quiz';
import LearnExplore from './pages/LearnExplore';
import Competition from './pages/Competition';
import Season2026 from './pages/Season2026';
import CompetitionRules from './pages/CompetitionRules';
import FAQ from './pages/FAQ';
import Register from './pages/Register';
import Login from './pages/Login';
import Support from './pages/Support';
import CorporateSponsorship from './pages/CorporateSponsorship';
import Contact from './pages/Contact';
import Profile from './pages/Profile';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import HowToChooseVariation from './pages/HowToChooseVariation';
import AuditionPrep from './pages/AuditionPrep';
import BeginnersGuide from './pages/BeginnersGuide';
import AuthCallback from './pages/AuthCallback';
import ResetPassword from './pages/ResetPassword';
import Report from './pages/Report';

// Import registration pages
import IndividualRegistration from './pages/registration/IndividualRegistration';
import RegistrationSuccess from './pages/registration/RegistrationSuccess';
import SchoolRegistration from './pages/registration/school/SchoolRegistration';
import ParentConsentPage from './pages/registration/school/ParentConsentPage';

// Import components
import ScrollToTop from './components/ScrollToTop';
import { AuthProvider } from './contexts/AuthContext';

// Import styles
import './styles/style.css';
import './App.css';

function App() {
  return (
    <Router>
      <AuthProvider>
        <ScrollToTop />
        <div className="App">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/quiz" element={<Quiz />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path="/reset-password" element={<ResetPassword />} />

            <Route path="/competition" element={<Competition />} />
            <Route path="/2026" element={<Season2026 />} />
            <Route path="/competition-rules" element={<CompetitionRules />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/register" element={<Register />} />
            <Route path="/register/individual/*" element={<IndividualRegistration />} />
            <Route path="/register/individual/success" element={<RegistrationSuccess />} />
            <Route path="/register/school/*" element={<SchoolRegistration />} />
            <Route path="/school/parent-consent/:token" element={<ParentConsentPage />} />
            <Route path="/login" element={<Login />} />
            <Route path="/support" element={<Support />} />
            <Route path="/corporate-sponsorship" element={<CorporateSponsorship />} />
            <Route path="/learn-explore" element={<LearnExplore />} />
            <Route path="/learn-explore/how-to-choose-variation" element={<HowToChooseVariation />} />
            <Route path="/learn-explore/audition-prep" element={<AuditionPrep />} />
            <Route path="/learn-explore/beginners-guide" element={<BeginnersGuide />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/report/:registrationId" element={<Report />} />
          </Routes>
        </div>
      </AuthProvider>
    </Router>
  );
}

export default App; 